import { render, staticRenderFns } from "./ContentDisplay.vue?vue&type=template&id=27e4d88e&"
import script from "./ContentDisplay.vue?vue&type=script&lang=js&"
export * from "./ContentDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ContentDisplay.vue?vue&type=style&index=0&module=true&lang=scss&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./ContentDisplay.vue?vue&type=style&index=0&module=true&lang=scss&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./ContentDisplay.vue?vue&type=style&index=0&module=true&lang=scss&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js").rerender("27e4d88e")
            }
          }
        })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e4d88e')) {
      api.createRecord('27e4d88e', component.options)
    } else {
      api.reload('27e4d88e', component.options)
    }
    module.hot.accept("./ContentDisplay.vue?vue&type=template&id=27e4d88e&", function () {
      api.rerender('27e4d88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentDisplay.vue"
export default component.exports